const getOffers = (url: string) => {
  return fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: new Headers({
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }),
  })
    .then(offersResponse => {
      return offersResponse.json();
    })
    .then(data => {
      const jsonData = JSON.parse(data);
      return jsonData.specialOfferList;
    })
    .catch(err => err);
};

export { getOffers };
